<template>
  <div
    class="date-picker-container"
    tabindex="0"
    @blur="checkBlur($event)"
  >
    <div :class="isDayView ? 'date-picker-calendar-view' : 'date-picker-collapse-view'">
      <div class="date-picker-header">
        <div class="date-picker-previous-button">
          <m-icon
            ref="datePickerPreviousButton"
            class="date-picker--no-outline"
            variant="chevron-left"
            tabindex="0"
            @click.native="updateMonth(-offsetValue)"
            @blur.native="checkBlur($event)"
          />
        </div>
        <div
          class="date-picker-header-title"
          @click="updateDatePickerView"
        >
          {{ getHeaderCopy }}
        </div>
        <div class="date-picker-next-button">
          <m-icon
            ref="datePickerNextButton"
            variant="chevron-right"
            class="date-picker--no-outline"
            tabindex="0"
            @click.native="updateMonth(offsetValue)"
            @blur.native="checkBlur($event)"
          />
        </div>
      </div>
      <div class="date-picker-body">
        <div
          v-if="isDayView"
          class="date-picker-day-container"
        >
          <div
            v-for="day in dayList"
            :key="day"
            class="date-picker-day"
          >
            {{ day }}
          </div>
        </div>
        <div class="date-picker-content">
          <m-date-picker-day-picker
            v-if="isDayView"
            :previous-date-list="previousDateList"
            :next-date-list="nextDateList"
            :current-date-list="currentDateList"
            :picker-date="pickerDate"
            :picker-month="pickerMonth"
            :picker-year="pickerYear"
            :selected-date="selectedDate"
            :selected-month="selectedMonth"
            :selected-year="selectedYear"
            :language="language"
            :disabled-dates="disabledDates"
            @update-selected-date="updateSelectedDate"
          />
          <m-date-picker-month-picker
            v-if="isMonthView"
            :picker-month="pickerMonth"
            :picker-year="pickerYear"
            :selected-month="selectedMonth"
            :selected-year="selectedYear"
            :language="language"
            :disabled-dates="disabledDates"
            @update-selected-date="updateSelectedDate"
          />
          <m-date-picker-year-picker
            v-if="isYearView"
            :picker-year="pickerYear"
            :selected-year="selectedYear"
            :year-list="getYearList"
            :language="language"
            :disabled-dates="disabledDates"
            @update-selected-date="updateSelectedDate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MDatePickerDayPicker from './DatePickerDayPicker';
import MDatePickerMonthPicker from './DatePickerMonthPicker';
import MDatePickerYearPicker from './DatePickerYearPicker';
import MIcon from '../../Icon';
import DatePickerMixins from '../mixins';
import locale from '../locale';

export default {
  name: 'MDatePickerContainer',
  components: {
    MIcon,
    MDatePickerDayPicker,
    MDatePickerMonthPicker,
    MDatePickerYearPicker,
  },
  mixins: [
    DatePickerMixins,
  ],
  props: {
    previousDateList: {
      type: Array,
      default: () => [],
    },
    nextDateList: {
      type: Array,
      default: () => [],
    },
    currentDateList: {
      type: Array,
      default: () => [],
    },
    pickerDate: {
      type: Number,
      default: 1,
    },
    pickerMonth: {
      type: Number,
      default: 0,
    },
    pickerYear: {
      type: Number,
      default: 2020,
    },
    selectedDate: {
      type: Number,
      default: 1,
    },
    selectedMonth: {
      type: Number,
      default: 0,
    },
    selectedYear: {
      type: Number,
      default: 2020,
    },
    datePickerView: {
      type: String,
      default: 'day',
    },
    language: {
      type: String,
      default: 'en',
    },
    disabledDates: {
      type: Object, 
      default: null,
    },
  },
  data: () => ({
    offsetValue: 1,
  }),
  watch: {
    datePickerView() {
      if (this.isDayView) {
        this.offsetValue = 1;
      } else if (this.isMonthView) {
        this.offsetValue = 12;
      } else {
        this.offsetValue = 144;
      }
    },
  },
  computed: {
    dayList() {
      return locale.dictionary[this.language].shortWeekdays;
    },
    pickerShortMonth() {
      const monthCount = 12;
      return locale.dictionary[this.language].fullMonths[this.pickerMonth % monthCount];
    },
    isDayView() {
      return this.datePickerView === 'day';
    },
    isMonthView() {
      return this.datePickerView === 'month';
    },
    isYearView() {
      return this.datePickerView === 'year';
    },
    getHeaderCopy() {
      if (this.isDayView) {
        return `${this.pickerShortMonth} ${this.pickerYear}`;
      } if (this.isMonthView) {
        return `${this.pickerYear}`;
      }
      return `${this.getYearList[0]} - ${this.getYearList[11]}`;
    },
    getYearList() {
      const yearList = [];
      const previousYearCount = 6;
      const nextYearCount = 5;
      for (let i = this.pickerYear - previousYearCount; i <= this.pickerYear + nextYearCount; i += 1) {
        yearList.push(i);
      }
      return yearList;
    },
  },
  methods: {
    updateSelectedDate(date) {
      this.$emit('update-selected-date', date);
    },
    updateDatePickerView() {
      if (this.isDayView) {
        this.$emit('update-view', 'month');
      } else {
        this.$emit('update-view', 'year');
      }
    },
    updateMonth(val) {
      this.$emit('update-month', val);
    },
  },
};
</script>
